import { Helmet } from 'react-helmet-async';
import InterviewCreateView from 'src/sections/interview/view/interview-create-view';
// sections
import { JobCreateView } from 'src/sections/job/view';

// ----------------------------------------------------------------------

export default function InterviewCreatePage() {
  return (
    <>
      <Helmet>
        <title> Hireintel - Create a new Interview</title>
      </Helmet>

      <InterviewCreateView />
    </>
  );
}
